// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o_SdKWERi9s8BHQPlfra {
  flex: 1 1 auto;
  width: 100%;
  position: relative;
}

.Ewa_93r7Yl42IFXq_UCN {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--loading-overlay-background);
  z-index: 7;
}

.gyDwChfyzMuNo7M7_IcC {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 8;
}

.MZxKsw2zkFhT9Na0iCGo {
  position: fixed;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingWrapper/LoadingWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".loadingWrapper {\n  flex: 1 1 auto;\n  width: 100%;\n  position: relative;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--loading-overlay-background);\n  z-index: 7;\n}\n\n.loadingBar {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  position: absolute;\n  z-index: 8;\n}\n\n.loadingBarFixed {\n  position: fixed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingWrapper": `o_SdKWERi9s8BHQPlfra`,
	"overlay": `Ewa_93r7Yl42IFXq_UCN`,
	"loadingBar": `gyDwChfyzMuNo7M7_IcC`,
	"loadingBarFixed": `MZxKsw2zkFhT9Na0iCGo`
};
export default ___CSS_LOADER_EXPORT___;
